import { PhoneNumberDynamicVariablesDetail } from "./BatchMessageGroupDetailModel";
import { MessageDetail } from "./BatchMessageSchedulingDetailModel";

export default class BatchMessagePreviewModel {
	public preSubmissionConfigurationId: string;
	public messages: MessageDetail[];
	public phoneNumbers: PhoneNumberDynamicVariablesDetail[];
	public partitionKey: string;

	public constructor() {
		this.preSubmissionConfigurationId = "";
		this.messages = [];
		this.phoneNumbers = [];
		this.partitionKey = "";
	}
}
